export default [
  {
    title: 'Dashboard',
    to: 'dashboard',
    icon: { icon: 'tabler-smart-home' },
    subject: 'dashboard',
    action: 'read',
  },
  {
    title: 'Quản lý số yêu cầu',
    to: 'projects',
    icon: { icon: 'tabler-clipboard-check' },
    subject: 'projects',
    action: 'read',
  },
  {
    title: 'Sản phẩm và phương pháp',
    to: 'products',
    icon: { icon: 'tabler-building-store' },
    subject: 'product',
    action: 'read',
  },
  {
    title: 'Phương pháp rủi ro',
    to: 'product-erp',
    icon: { icon: 'tabler-shield-exclamation' },
    subject: 'product-erp',
    action: 'read',
  },
  {
    title: 'Mẫu in',
    to: 'print-template',
    icon: { icon: 'tabler-printer' },
    children: [
      {
        title: 'Mẫu in',
        to: 'print-template',
        icon: { icon: 'tabler-printer' },
        subject: 'print-template',
        action: 'read',
      },
      {
        title: 'Tham số mẫu in PDF',
        to: 'print-template-print-template-param',
        icon: { icon: 'tabler-printer' },
        subject: 'print-params',
        action: 'read',
      },
      {
        title: 'Thông tin liên hệ trên mẫu',
        to: 'print-template-contact-information-on-template',
        icon: { icon: 'tabler-printer' },
        subject: 'contact-info',
        action: 'read',
      },
    ],
  },
  {
    title: 'Nhân sự',
    to: 'staff',
    icon: { icon: 'tabler-users' },
    subject: 'staff',
    action: 'read',
  },
  {
    title: 'Phòng ban/Đơn vị thành viên',
    to: 'departments',
    icon: { icon: 'tabler-building-community' },
    subject: 'departments',
    action: 'read',
  },
  {
    title: 'Trang thiết bị',
    to: 'devices',
    icon: { icon: 'tabler-devices-pc' },
    children: [
      {
        title: 'Thiết bị',
        to: 'devices',
        icon: { icon: 'tabler-printer' },
        subject: 'device',
        action: 'read',
      },
      {
        title: 'Loại/ nhóm thiết bị',
        to: 'devices-categories',
        icon: { icon: 'tabler-printer' },
        subject: 'devices',
        action: 'read',
      },
    ],
  },
  {
    title: 'Nhà thầu phụ',
    to: 'subcontractors',
    icon: { icon: 'tabler-home-ribbon' },
    subject: 'subcontractor',
    action: 'read',
  },
  {
    title: 'Quản lý tài liệu',
    to: 'documents',
    icon: { icon: 'tabler-book-2' },
    action: 'read',
    children: [
      {
        title: 'Tài liệu của tôi',
        to: 'documents',
        icon: { icon: 'tabler-briefcase' },
        subject: 'document',
        action: 'read',
      },
      {
        title: 'Chia sẻ với tôi',
        to: 'documents-document-shares',
        icon: { icon: 'tabler-printer' },
        subject: 'document',
        action: 'read',
      },
      {
        title: 'Thùng rác',
        to: 'documents-document-trashes',
        icon: { icon: 'tabler-printer' },
        subject: 'document',
        action: 'read',
      },
    ],
  },
  {
    title: 'Báo cáo',
    to: 'reports',
    icon: { icon: 'tabler-chart-pie' },
    children: [
      {
        title: 'Báo cáo loại hình',
        to: 'reports-inspection-type',
        icon: { icon: 'tabler-printer' },
        subject: 'report',
        action: 'inspection-type',
      },
      {
        title: 'Báo cáo tiến độ dự án',
        to: 'reports-project-progress',
        icon: { icon: 'tabler-chart-bar' },
        subject: 'report',
        action: 'project-progress',
      },
      {
        title: 'Báo cáo hậu kiểm',
        to: 'reports-review-project',
        icon: { icon: 'tabler-printer' },
        subject: 'report',
        action: 'post-project-audits',
      },
      {
        title: 'Báo cáo nhân viên',
        to: 'reports-staff',
        icon: { icon: 'tabler-printer' },
        subject: 'report',
        action: 'staff',
      },
      {
        title: 'Thống kê số liệu',
        to: 'reports-measure',
        icon: { icon: 'tabler-printer' },
        subject: 'report',
        action: 'measure',
      },
    ],
  },
  {
    title: 'Hậu kiểm',
    to: 'post-project-audits',
    icon: { icon: 'tabler-checklist' },
    subject: 'post-project-audits',
    action: 'read',
  },
  {
    title: 'Lịch sử',
    to: 'histories',
    icon: { icon: 'tabler-history' },
    subject: 'history',
    action: 'read',
  },
  {
    title: 'Thông báo',
    to: 'notifications',
    icon: { icon: 'tabler-speakerphone' },
    subject: 'notification',
    action: 'read',
  },
  {
    title: 'Phân quyền',
    to: 'roles',
    icon: { icon: 'tabler-shield-lock' },
    subject: 'role',
    action: 'read',
  },
  {
    title: 'Cài đặt',
    to: 'settings',
    icon: { icon: 'tabler-settings' },
    subject: 'settings',
    action: 'read',
  },
]
